/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_Policy_Delete_AnyInputs */



/**
* | output |
* | --- |
* | "Removed access" |
*
* @param {Activity_Policy_Delete_AnyInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const activity_policy_delete_any = /** @type {((inputs?: Activity_Policy_Delete_AnyInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Policy_Delete_AnyInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалён доступ")
	return /** @type {LocalizedString} */ ("Removed access")
});